import moment from 'moment';
import 'popper.js';

window.scheduleCalendar = (params) => {
    moment.locale('ru');

    const url = params.url
    const dataUrl = params.dataUrl || null

    let type = params.type
    let notification = params.notification
    let responsibleTelegram = params.responsibleTelegram
    let responsibleMax = params.responsibleMax
    let admins = params.admins || {}
    let adminColor = params.adminColor || {}
    let adminCalendar = params.adminCalendar || {}
    let initialAdminCalendar = {}
    let adminTempCalendar = {}
    let virtualNumbers = Array.isArray(params.virtualNumbers) ? params.virtualNumbers : Object.values(params.virtualNumbers || {})
    virtualNumbers = virtualNumbers.map((number) => number.toString())
    let branches = params.branches || []
    let branchNumbersMap = {}
    let currentBranchId = null
    let dateSeries = []
    let currentDate = moment().startOf('week')
    let hasUnsavedChanges = false
    let isCalendarLoaded = false
    let isCalendarLoading = false
    let isCalendarSaving = false

    const normalizeBranchId = (branchId) => {
        if (branchId === null || typeof branchId === 'undefined') {
            return null
        }
        return branchId.toString()
    }

    const prepareBranchData = () => {
        branchNumbersMap = {}
        branches = Array.isArray(branches) ? branches : []
        branches.forEach((branch) => {
            if (!branch) {
                return
            }
            const key = normalizeBranchId(branch.id)
            if (key === null) {
                return
            }
            const numbers = Array.isArray(branch.numbers) ? branch.numbers : []
            branchNumbersMap[key] = numbers.filter((number) => !!number).map((number) => number.toString())
        })
    }

    const isBranchContext = () => currentBranchId !== null

    const getCurrentBranchNumbers = () => {
        if (!isBranchContext()) {
            return []
        }
        return branchNumbersMap[currentBranchId] || []
    }

    const hasNumbersForCurrentBranch = () => getCurrentBranchNumbers().length > 0

    const isNumberAllowedForCurrentBranch = (number) => {
        if (!isBranchContext()) {
            return true
        }
        if (!number) {
            return false
        }
        return getCurrentBranchNumbers().includes(number.toString())
    }

    const setCurrentBranch = (branchId) => {
        const normalizedId = normalizeBranchId(branchId)
        if (currentBranchId === normalizedId) {
            return
        }
        currentBranchId = normalizedId
        updateNumberSelectOptions()
        renderCalendar()
        renderBranchTabs()
    }

    const renderBranchTabs = () => {
        const container = $('#branch-tabs')
        if (!container.length) {
            return
        }

        const navList = $('<ul class="nav nav-tabs mb-3" role="tablist"></ul>')

        const appendTab = (id, label) => {
            const normalizedId = normalizeBranchId(id)
            const isActive = normalizedId === currentBranchId
            const button = $('<button type="button" class="nav-link"></button>')
                .text(label || 'Филиал')
                .toggleClass('active', isActive)
                .attr('data-branch-id', normalizedId ?? '')
                .attr('type', 'button')
                .on('click', () => setCurrentBranch(normalizedId))

            if (isActive) {
                button.attr('aria-current', 'page')
            }

            const listItem = $('<li class="nav-item"></li>').append(button)
            navList.append(listItem)
        }

        appendTab(null, 'Общий')
        branches.forEach((branch) => {
            appendTab(branch.id, branch.name)
        })

        container.empty().append(navList)
    }

    const updateNumberSelectOptions = () => {
        const numberSelect = $('#number')
        if (!numberSelect.length) {
            return
        }

        const currentValue = numberSelect.val()
        numberSelect.empty()

        if (!isBranchContext()) {
            numberSelect.append(new Option('Любой номер', ''))
            virtualNumbers.forEach((number) => {
                numberSelect.append(new Option(number, number))
            })

            if (currentValue && virtualNumbers.includes(currentValue)) {
                numberSelect.val(currentValue)
            } else {
                numberSelect.val('')
            }

            return
        }

        const branchNumbers = getCurrentBranchNumbers()

        if (!branchNumbers.length) {
            const option = new Option('Для филиала не настроены номера', '')
            option.disabled = true
            option.selected = true
            numberSelect.append(option)
            return
        }

        numberSelect.append(new Option('Выберите номер филиала', ''))
        branchNumbers.forEach((number) => {
            numberSelect.append(new Option(number, number))
        })

        if (branchNumbers.includes(currentValue)) {
            numberSelect.val(currentValue)
        } else {
            numberSelect.val('')
        }
    }

    const getFilteredAdminCalendar = () => {
        if (!isBranchContext()) {
            return adminCalendar
        }

        const branchNumbers = getCurrentBranchNumbers()
        const filtered = {}

        for (let adminCalendarKey in adminCalendar) {
            const items = adminCalendar[adminCalendarKey] || []
            filtered[adminCalendarKey] = items.filter((item) => {
                if (!item.number) {
                    return false
                }
                return branchNumbers.includes(item.number.toString())
            })
        }

        return filtered
    }

    const init = () => {
        type = $('[name="type"]:checked').val()
        notification = $('[name="notification"]').is(':checked')
        responsibleTelegram = $('[name="responsibleTelegram"]').val()
        responsibleMax = $('[name="responsibleMax"]').val()

        ensureCalendarStatusElements()
        event()
        renderCalendar()
        loadCalendarData()

        window.addEventListener('beforeunload', (event) => {
            if (!hasUnsavedChanges) {
                return
            }
            // Предупреждаем пользователя о несохранённых изменениях
            event.preventDefault()
            event.returnValue = 'Есть несохранённые изменения расписания. Сохраните их перед закрытием вкладки.'
        })

        // При старте скрываем предупреждение, если изменений нет
        $('#calendar-alert').hide()
        renderPriorityWarning()
    }

    const ensureCalendarStatusElements = () => {
        if (!$('#calendar-loading-alert').length) {
            $('#calendar-alert').before(
                '<div id="calendar-loading-alert" class="alert alert-info calendar-alert" role="alert">' +
                    '<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>' +
                    'Загрузка расписания...' +
                '</div>'
            )
        }

        if (!$('#calendar-load-error').length) {
            $('#calendar-loading-alert').after(
                '<div id="calendar-load-error" class="alert alert-danger calendar-alert" role="alert">' +
                    '<span class="calendar-load-error-text">Не удалось загрузить расписание.</span> ' +
                    '<button type="button" id="reload-calendar-data" class="btn btn-sm btn-outline-danger ml-2">Повторить</button>' +
                '</div>'
            )
        }
    }

    const setCalendarControlsDisabled = (isDisabled) => {
        $('#clear-calendar, #save-calendar, #prevMonth, #prevWeek, #nextWeek, #nextMonth, #admin, #number, #time_from, #time_to, #type1, #type2, #notification, [name="responsibleTelegram"], [name="responsibleMax"]')
            .prop('disabled', isDisabled)
    }

    const setCalendarLoading = (isLoading) => {
        isCalendarLoading = isLoading
        $('#calendar-loading-alert').toggle(isLoading)
        $('#calendar-load-error').hide()
        setCalendarControlsDisabled(isLoading || !isCalendarLoaded)
    }

    const setCalendarLoadError = (message) => {
        isCalendarLoading = false
        isCalendarLoaded = false
        $('#calendar-loading-alert').hide()
        $('#calendar-load-error .calendar-load-error-text').text(message || 'Не удалось загрузить расписание. Попробуйте повторить загрузку.')
        $('#calendar-load-error').show()
        setCalendarControlsDisabled(true)
        renderPriorityWarning()
    }

    const applyCalendarData = (data) => {
        admins = data.admins || {}
        adminColor = data.adminColor || {}
        adminCalendar = normalizeAdminCalendar(data.adminCalendar || {})
        initialAdminCalendar = cloneCalendar(adminCalendar)
        virtualNumbers = Array.isArray(data.virtualNumbers) ? data.virtualNumbers : Object.values(data.virtualNumbers || {})
        virtualNumbers = virtualNumbers.map((number) => number.toString())
        branches = data.branches || []

        isCalendarLoaded = true
        isCalendarLoading = false
        hasUnsavedChanges = false

        prepareBranchData()
        renderBranchTabs()
        updateNumberSelectOptions()
        handlerType()

        $('#calendar-alert').hide()
        $('#calendar-loading-alert').hide()
        $('#calendar-load-error').hide()
        setCalendarControlsDisabled(false)
        renderPriorityWarning()
    }

    const loadCalendarData = () => {
        if (!dataUrl) {
            applyCalendarData(params)
            return
        }

        setCalendarLoading(true)

        $.ajax({
            type: 'GET',
            url: dataUrl,
            dataType: 'json',
            success: applyCalendarData,
            error: function(xhr) {
                const response = xhr.responseJSON || {}
                setCalendarLoadError(response.message || 'Не удалось загрузить расписание. Проверьте подключение и повторите попытку.')
            }
        })
    }


    const event = () => {
        $('.calendar-container').on('click' , 'td', handlerCheck)
        $('#reload-calendar-data').on('click', loadCalendarData)
        $('#clear-calendar').on('click', () => {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            const assignmentsCount = countCalendarItems(adminCalendar)
            if (assignmentsCount < 1) {
                return
            }
            if (!confirm(`Будет удалено ${assignmentsCount} назначений. Очистить весь календарь?`)) {
                return
            }
            for (let adminCalendarKey in adminCalendar) {
                adminCalendar[adminCalendarKey] = []
            }
            hasUnsavedChanges = true
            $('#calendar-alert').show()
            renderCalendar()
            renderPriorityWarning()
        })
        $('#save-calendar').on('click', handlerSave)
        $('#notification').on('change', () => {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            notification = $('[name="notification"]').is(':checked')
            hasUnsavedChanges = true
            $('#calendar-alert').show()
        })
        $('[name="responsibleTelegram"]').on('change', () => {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            responsibleTelegram = $('[name="responsibleTelegram"]').val()
            hasUnsavedChanges = true
            $('#calendar-alert').show()
        })
        $('[name="responsibleMax"]').on('change', () => {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            responsibleMax = $('[name="responsibleMax"]').val()
            hasUnsavedChanges = true
            $('#calendar-alert').show()
        })
        $('#type1, #type2').on('change', () => {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            type = $('[name="type"]:checked').val()
            handlerType()
            hasUnsavedChanges = true
            $('#calendar-alert').show()
        })

        $('#prevMonth').on('click', function () {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            currentDate.subtract(4, 'M')
            renderCalendar()
        })
        $('#prevWeek').on('click', function () {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            currentDate.subtract(1, 'w')
            renderCalendar()
        })
        $('#nextWeek').on('click', function () {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            currentDate.add(1, 'w')
            renderCalendar()
        })
        $('#nextMonth').on('click', function () {
            if (!isCalendarLoaded || isCalendarLoading) {
                return
            }
            currentDate.add(4, 'M')
            renderCalendar()
        })
    }

    const handlerType = () => {
        console.log(type)
        if (type === 'double') {
            //проверить что отмечены 2 аминистратора по 2 смены подряд
            const today = moment().startOf('day')
            dateSeries = []
            for (let adminCalendarKey in adminCalendar) {
                adminCalendar[adminCalendarKey].map(function(item) {
                    if (!item?.date || moment(item.date, 'YYYY-MM-DD').isBefore(today, 'day')) {
                        return
                    }

                    dateSeries.push({
                        date: item.date,
                        number: item.number,
                        time_from: item.time_from || null,
                        time_to: item.time_to || null,
                        admin: adminCalendarKey
                    })
                })
            }

            dateSeries.sort((a, b) => {
                return moment(a.date).diff(moment(b.date))
            })

            console.log(dateSeries)

            if (dateSeries.length >= 4) {
                if (validateDateSeries(dateSeries)) {
                    // заполняем временое расписание 2/2
                    const firstDate = moment(dateSeries[0].date)
                    const adminFirst = dateSeries[0].admin
                    const adminTwo = dateSeries[2].admin
                    const numberFirst = dateSeries[0].number
                    const numberTwo = dateSeries[2].number

                    for (let i = 0; i < 60; i++) {
                        // Увеличиваем дату на 1 день
                        let newDate = firstDate.format('YYYY-MM-DD');

                        // Определяем admin: чередуем каждые два элемента
                        let admin = (i % 4 < 2) ? adminFirst : adminTwo;
                        let number = (i % 4 < 2) ? numberFirst : numberTwo;

                        firstDate.add(1, 'days')
                    }

                } else {
                    $('#type2').prop('checked', true);
                    type = 'custom'
                }
            }

        }
        renderCalendar()
    }

    const validateDateSeries = (dateSeries) => {
        if (dateSeries.length < 1) {
            return false;
        }

        const today = moment().startOf('day')
        const actualDateSeries = dateSeries.filter((item) => {
            return item?.date && !moment(item.date, 'YYYY-MM-DD').isBefore(today, 'day')
        })

        if (actualDateSeries.length < 1) {
            return false;
        }

        // Группируем администраторов по датам
        const adminsByDate = {};
        actualDateSeries.forEach(item => {
            if (!adminsByDate[item.date]) {
                adminsByDate[item.date] = [];
            }
            adminsByDate[item.date].push(item.admin);
        });

        // Сортируем даты
        const dates = Object.keys(adminsByDate).sort((a, b) => moment(a).diff(moment(b)));

        // Проверка последовательности дат без пропусков
        for (let i = 1; i < dates.length; i++) {
            if (moment(dates[i]).diff(moment(dates[i - 1]), 'days') !== 1) {
                return false;
            }
        }

        // Успешная проверка для 4 или более дней
        if (dates.length >= 4) {
            for (let i = 0; i < dates.length; i++) {
                const currentAdmins = adminsByDate[dates[i]].sort();
                // Проверяем дни, отстоящие на 4 дня
                for (let j = i + 4; j < dates.length; j += 4) {
                    const nextAdmins = adminsByDate[dates[j]].sort();
                    if (JSON.stringify(currentAdmins) !== JSON.stringify(nextAdmins)) {
                        return false;
                    }
                }
            }
            return true;
        }

        return false;
    }

    const cloneCalendar = (calendar) => {
        return JSON.parse(JSON.stringify(calendar || {}))
    }

    const normalizeAdminCalendar = (calendar) => {
        const normalized = {}

        Object.keys(calendar || {}).forEach((adminId) => {
            normalized[adminId] = normalizeItems(calendar[adminId] || [])
        })

        return normalized
    }

    const normalizeItems = (items) => {
        const uniqueItems = {}

        ;(items || []).forEach((item) => {
            if (!item || !item.date) {
                return
            }

            const number = item.number ? item.number.toString().trim() : ''
            const timeFrom = normalizeTimeValue(item.time_from || item.timeFrom || null)
            const timeTo = normalizeTimeValue(item.time_to || item.timeTo || null)
            const normalizedItem = {
                date: item.date,
                number: number || null,
                time_from: timeFrom,
                time_to: timeTo
            }

            if (!isValidTimeInterval(normalizedItem.time_from, normalizedItem.time_to)) {
                return
            }

            uniqueItems[getCalendarItemKey(normalizedItem)] = normalizedItem
        })

        return Object.values(uniqueItems)
    }

    const getCalendarItemKey = (item) => {
        return `${item.date}|${item.number || '__empty__'}|${item.time_from || '__start__'}|${item.time_to || '__end__'}`
    }

    const flattenCalendar = (calendar) => {
        const items = []

        Object.keys(calendar || {}).forEach((adminId) => {
            ;(calendar[adminId] || []).forEach((item) => {
                if (!item || !item.date) {
                    return
                }

                const number = item.number ? item.number.toString().trim() : ''
                items.push({
                    user_id: parseInt(adminId, 10),
                    date: item.date,
                    number: number || null,
                    time_from: normalizeTimeValue(item.time_from || item.timeFrom || null),
                    time_to: normalizeTimeValue(item.time_to || item.timeTo || null)
                })
            })
        })

        return items
    }

    const getFlatItemKey = (item) => {
        return `${item.user_id}|${item.date}|${item.number || '__empty__'}|${item.time_from || '__start__'}|${item.time_to || '__end__'}`
    }

    const buildCalendarDiff = () => {
        const initialItems = flattenCalendar(initialAdminCalendar)
        const currentItems = flattenCalendar(adminCalendar)
        const initialMap = {}
        const currentMap = {}

        initialItems.forEach((item) => {
            initialMap[getFlatItemKey(item)] = item
        })
        currentItems.forEach((item) => {
            currentMap[getFlatItemKey(item)] = item
        })

        const added = Object.keys(currentMap)
            .filter((key) => !initialMap[key])
            .map((key) => currentMap[key])
        const removed = Object.keys(initialMap)
            .filter((key) => !currentMap[key])
            .map((key) => initialMap[key])

        return {added, removed}
    }

    const countCalendarItems = (calendar) => {
        return flattenCalendar(calendar).length
    }

    const normalizeTimeValue = (value) => {
        if (value === null || typeof value === 'undefined') {
            return null
        }

        const time = value.toString().trim()
        if (!time) {
            return null
        }

        const match = time.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)
        if (!match) {
            return null
        }

        const hours = parseInt(match[1], 10)
        const minutes = parseInt(match[2], 10)
        if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
            return null
        }

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
    }

    const timeToMinutes = (time) => {
        const parts = time.split(':').map((part) => parseInt(part, 10))
        return parts[0] * 60 + parts[1]
    }

    const isValidTimeInterval = (timeFrom, timeTo) => {
        if (!timeFrom || !timeTo) {
            return true
        }

        return timeToMinutes(timeFrom) < timeToMinutes(timeTo)
    }

    const getIntervalMinutes = (item) => {
        return [
            item.time_from ? timeToMinutes(item.time_from) : 0,
            item.time_to ? timeToMinutes(item.time_to) : 24 * 60
        ]
    }

    const intervalsOverlap = (firstItem, secondItem) => {
        const [firstStart, firstEnd] = getIntervalMinutes(firstItem)
        const [secondStart, secondEnd] = getIntervalMinutes(secondItem)

        return firstStart < secondEnd && secondStart < firstEnd
    }

    const hasOverlappingUsers = (items) => {
        for (let i = 0; i < items.length; i++) {
            for (let j = i + 1; j < items.length; j++) {
                if (items[i].adminId.toString() === items[j].adminId.toString()) {
                    continue
                }

                if (intervalsOverlap(items[i], items[j])) {
                    return true
                }
            }
        }

        return false
    }

    const formatScheduleTime = (item) => {
        const timeFrom = item.time_from || null
        const timeTo = item.time_to || null

        if (timeFrom && timeTo) {
            return `${timeFrom}-${timeTo}`
        }

        if (timeFrom) {
            return `с ${timeFrom}`
        }

        if (timeTo) {
            return `до ${timeTo}`
        }

        return 'весь день'
    }

    const getTempCalendar = () => {
        if (type !== 'double' || dateSeries.length < 4 || !validateDateSeries(dateSeries)) {
            return {}
        }

        const uniqueDates = Array.from(new Set(dateSeries.map((item) => item.date)))
            .sort((a, b) => moment(a).diff(moment(b)))

        if (uniqueDates.length < 4) {
            return {}
        }

        const firstPatternDate = moment(uniqueDates[0], 'YYYY-MM-DD').startOf('day')
        const patternByOffset = {}

        uniqueDates.slice(0, 4).forEach((patternDate, index) => {
            patternByOffset[index] = dateSeries.filter((item) => item.date === patternDate)
        })

        const tempCalendar = {}
        const rangeStart = currentDate.clone().startOf('day')
        const rangeEnd = currentDate.clone().add(27, 'days').startOf('day')
        const currentTempDate = moment.max(firstPatternDate.clone(), rangeStart.clone())

        while (currentTempDate.isSameOrBefore(rangeEnd, 'day')) {
            const diffDays = currentTempDate.diff(firstPatternDate, 'days')
            const offset = ((diffDays % 4) + 4) % 4
            tempCalendar[currentTempDate.format('YYYY-MM-DD')] = patternByOffset[offset] || []
            currentTempDate.add(1, 'day')
        }

        return tempCalendar
    }


    const handlerCheck = function() {
        if (!isCalendarLoaded || isCalendarLoading || isCalendarSaving) {
            return
        }

        const td = $(this)
        const currentAdmin = $('#admin').val()
        const currentNumber = $('#number').val()
        const timeFrom = normalizeTimeValue($('#time_from').val())
        const timeTo = normalizeTimeValue($('#time_to').val())

        if (!isValidTimeInterval(timeFrom, timeTo)) {
            alert('Время начала должно быть меньше времени окончания')
            return
        }

        if (currentAdmin) {
            if (!adminCalendar[currentAdmin]) {
                adminCalendar[currentAdmin] = []
            }
            if (isBranchContext()) {
                if (!hasNumbersForCurrentBranch()) {
                    alert('Для выбранного филиала не настроены номера')
                    return
                }
                if (!currentNumber) {
                    alert('Выберите номер филиала')
                    return
                }
                if (!isNumberAllowedForCurrentBranch(currentNumber)) {
                    alert('Выбранный номер не относится к филиалу')
                    return
                }
            }

            // при нажатии добавить или убрать из массива adminCalendar
            const newItem = {
                date: td.attr('data-date'),
                number: currentNumber,
                time_from: timeFrom,
                time_to: timeTo
            }
            const newItemKey = getCalendarItemKey(newItem)

            if (adminCalendar[currentAdmin].filter(function(item) {
                return getCalendarItemKey(item) === newItemKey
            }).length > 0) {
                adminCalendar[currentAdmin] = adminCalendar[currentAdmin].filter(function(item) {
                    return getCalendarItemKey(item) !== newItemKey
                })
            } else {
                adminCalendar[currentAdmin].push(newItem)
            }
            hasUnsavedChanges = true
            handlerType()
            renderCalendar()
            renderPriorityWarning()
            $('#calendar-alert').show()
        } else {
            alert('Не выбран администратор')
        }

    }

    const handlerSave = () => {
        if (!isCalendarLoaded || isCalendarLoading || isCalendarSaving) {
            return
        }

        const {added, removed} = buildCalendarDiff()
        isCalendarSaving = true
        setCalendarControlsDisabled(true)

        $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify({
                action: 'schedule-calendar',
                scheduleType: type,
                scheduleNotification: notification,
                scheduleResponsibleTelegram: responsibleTelegram,
                scheduleResponsibleMax: responsibleMax,
                added,
                removed
            }),
            contentType: 'application/json',
            success: function(result) {
                console.log(result)
                let message = 'Расписание сохранено'
                if (result.priority_notice) {
                    message += '\n\n' + result.priority_notice
                }
                alert(message)
                initialAdminCalendar = cloneCalendar(adminCalendar)
                hasUnsavedChanges = false
                $('#calendar-alert').hide()
                renderPriorityWarning()
            },
            error: function(xhr) {
                const response = xhr.responseJSON || {}
                alert(response.message || 'Ошибка при сохранении расписания. Попробуйте снова.')
                $('#calendar-alert').show()
            },
            complete: function() {
                isCalendarSaving = false
                setCalendarControlsDisabled(!isCalendarLoaded || isCalendarLoading)
            }
        })
    }

    const getPriorityWarningDates = () => {
        const itemsByDateWithoutNumber = {}
        const itemsByDateAndNumber = {}

        for (let adminId in adminCalendar) {
            const items = adminCalendar[adminId] || []
            items.forEach((item) => {
                const date = item && item.date
                if (!date) {
                    return
                }

                const number = item && item.number
                const hasNumber = number !== null && number !== undefined && number.toString().trim() !== ''
                const normalizedItem = {
                    adminId: adminId,
                    time_from: normalizeTimeValue(item.time_from || null),
                    time_to: normalizeTimeValue(item.time_to || null)
                }

                if (!hasNumber) {
                    if (!itemsByDateWithoutNumber[date]) {
                        itemsByDateWithoutNumber[date] = []
                    }
                    itemsByDateWithoutNumber[date].push(normalizedItem)
                    return
                }

                const normalizedNumber = number.toString().trim()
                const dateNumberKey = `${date}|${normalizedNumber}`
                if (!itemsByDateAndNumber[dateNumberKey]) {
                    itemsByDateAndNumber[dateNumberKey] = []
                }
                itemsByDateAndNumber[dateNumberKey].push(normalizedItem)
            })
        }

        const warningDates = new Set()

        Object.keys(itemsByDateWithoutNumber)
            .filter((date) => hasOverlappingUsers(itemsByDateWithoutNumber[date]))
            .forEach((date) => warningDates.add(date))

        Object.keys(itemsByDateAndNumber)
            .filter((key) => hasOverlappingUsers(itemsByDateAndNumber[key]))
            .forEach((key) => warningDates.add(key.split('|')[0]))

        return Array.from(warningDates)
            .sort((a, b) => moment(a).diff(moment(b)))
    }

    const renderPriorityWarning = () => {
        let warningElement = $('#calendar-priority-warning')
        if (!warningElement.length) {
            warningElement = $('<div id="calendar-priority-warning" class="alert alert-warning calendar-alert" role="alert"></div>')
            $('#calendar-alert').after(warningElement)
        }

        const today = moment().startOf('day')
        const warningDates = getPriorityWarningDates()
            .filter((date) => moment(date, 'YYYY-MM-DD').isSameOrAfter(today, 'day'))
        if (!warningDates.length) {
            warningElement.hide().text('')
            return
        }

        const formattedDates = warningDates.map((date) => moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY'))
        warningElement.text(
            `Предупреждение: на даты ${formattedDates.join(', ')} назначены несколько сотрудников без привязки к номеру или на один номер в пересекающееся время. ` +
            'За звонками будет закреплен последний добавленный сотрудник.'
        )
        warningElement.show()
    }

    const renderCalendar = () => {

        // Перед перерисовкой корректно убираем тултипы и их DOM-элементы
        try {
            $('#calendar tbody [data-toggle="tooltip"]').tooltip('dispose')
        } catch (e) {
            // игнорируем, если плагин недоступен
        }
        $('.tooltip').remove()

        $('#calendar tbody').html('')

        const date = currentDate.clone()
        const calendarToRender = getFilteredAdminCalendar()
        const tempCalendar = getTempCalendar()

        // Генерируем 4 недели
        for (let week = 0; week < 4; week++) {
            const row = document.createElement('tr');

            // Генерируем 7 дней для каждой недели
            for (let day = 0; day < 7; day++) {

                let active = false
                let temp = false
                let background = false
                let backgroundList = []
                const dateStr = date.format('YYYY-MM-DD')

                for (let adminCalendarKey in calendarToRender) {
                    const adminItems = calendarToRender[adminCalendarKey] || []
                    const dayItems = adminItems.filter(function(item) {
                        return item.date === dateStr
                    })

                    if (dayItems.length > 0) {
                        active = true
                        background = true
                        backgroundList.push(adminColor[adminCalendarKey])
                    }
                }

                const tempItems = active ? [] : (tempCalendar[dateStr] || [])
                if (tempItems.length > 0) {
                    temp = true
                    background = true

                    Array.from(new Set(tempItems.map((item) => item.admin)))
                        .forEach((adminId) => {
                            if (adminColor[adminId]) {
                                backgroundList.push(adminColor[adminId])
                            }
                        })
                }

                const cell = document.createElement('td');
                cell.setAttribute('data-date', dateStr);
                cell.classList.add('day');
                if (active) {
                    cell.classList.add('active');

                    // Bootstrap 4 совместимые атрибуты тултипа
                    cell.setAttribute("data-placement", "right")
                    cell.setAttribute("data-html", "true")

                    let text = '';

                    for (let adminCalendarKey in calendarToRender) {
                        calendarToRender[adminCalendarKey].filter(function(item) {
                            return item.date === dateStr
                        }).map(function(item) {
                            text += admins[adminCalendarKey] + '<br>'
                                + (item.number || 'Любой номер') + '<br>'
                                + formatScheduleTime(item) + '<br>'
                        })
                    }

                    cell.setAttribute("title", text)
                    cell.setAttribute("data-toggle", "tooltip")
                }
                if (temp) {
                    cell.classList.add('temp');
                }

                // Создаем div для заголовка
                const titleDiv = document.createElement('div');
                titleDiv.classList.add('title');

                const daySpan = document.createElement('span');
                daySpan.textContent = date.format('D');

                const monthSpan = document.createElement('span');
                monthSpan.textContent = date.format('MMM');

                titleDiv.appendChild(daySpan);
                titleDiv.appendChild(document.createElement('br'));
                titleDiv.appendChild(monthSpan);

                // Добавляем titleDiv и background div в ячейку
                cell.appendChild(titleDiv);
                const backgroundDiv = document.createElement('div');
                backgroundDiv.classList.add('background');
                if (background) {
                    backgroundList.forEach(function(element) {
                        const backgroundElementDiv = document.createElement('div');
                        backgroundElementDiv.classList.add('element');
                        backgroundElementDiv.style = `background-color: ${element}`
                        backgroundDiv.appendChild(backgroundElementDiv)
                    })
                }
                cell.appendChild(backgroundDiv)

                row.appendChild(cell);

                // Переходим к следующему дню
                date.add(1, 'd');
            }

            // Добавляем строку в тело таблицы
            $('#calendar tbody').append(row);
        }

        // Инициализируем тултипы один раз после полной отрисовки
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body',
            html: true,
            placement: 'right'
        })

        // $('.calendar-container td').each(function(index, element) {
        //     $(element)
        //         .removeClass('active')
        //         .find('.background').html('')
        //
        //     for (let adminCalendarKey in adminCalendar) {
        //         if (adminCalendar[adminCalendarKey].filter(function(item) {
        //             return item.date === $(element).attr('data-date')
        //         }).length > 0) {
        //
        //             $(element)
        //                 .addClass('active')
        //                 .find('.background').append('<div class="element" style="background-color: '+ adminColor[adminCalendarKey] +'"></div>')
        //         }
        //         //временый для 2/2
        //         if (adminTempCalendar[adminCalendarKey]?.filter(function(item) {
        //             return item.date === $(element).attr('data-date')
        //         }).length > 0) {
        //
        //             $(element)
        //                 .addClass('temp')
        //                 .find('.background').append('<div class="element" style="background-color: '+ adminColor[adminCalendarKey] +'"></div>')
        //         }
        //     }
        // })
    }

    init()
    return {
        isDirty: () => hasUnsavedChanges,
        isBusy: () => isCalendarLoading || isCalendarSaving,
        reload: loadCalendarData,
    }
}
